import { render, staticRenderFns } from "./position-structure-add.vue?vue&type=template&id=61ae5cb7";
import script from "./position-structure-add.vue?vue&type=script&lang=jsx";
export * from "./position-structure-add.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;